import { motion } from 'framer-motion';
import Typography from '@mui/material/Typography';

/**
 * SimpleHeader
 *
 * Componente de cabecera simple con título, descripción y contenido adicional.
 *
 * @component
 * @param {React.ReactNode} [children] - Elementos adicionales a mostrar en la cabecera
 * @param {string} [title] - Título principal
 * @param {string} [description] - Descripción secundaria
 * @returns {JSX.Element}
 */
export const SimpleHeader = ({ children, title, description }) => {
  return (
    <div className="relative flex flex-col w-full px-24 sm:px-32 sm:flex-row sm:items-center min-w-0 py-24">
      <motion.div
        className="flex flex-col min-w-0 mx-16"
        initial={{ x: -20, opacity: 0 }}
        animate={{ x: 0, transition: { delay: 0.3 }, opacity: 1 }}
      >
        <Typography className="text-2xl text-center md:text-left md:text-5xl font-semibold tracking-tight leading-7 md:leading-snug truncate">
          {title || 'Sin título'}
        </Typography>
        <div className="flex items-center">
          {description && (
            <Typography className="mx-6 leading-6 truncate" color="text.secondary">
              {description}
            </Typography>
          )}
        </div>
      </motion.div>
      {children && <div className="flex-1 min-w-0 mx-16">{children}</div>}
    </div>
  );
};
